import React, {useEffect, useState} from "react";
import {useTheme} from "./ThemeContext";
import axios from "axios";
import {Autocomplete, Box} from "@mui/material";
import {StyledChip} from "./buttons/StyledChip";
import {StyledTextField} from "../utils/Utils";

export const TagSearch = ({tags, setTags}) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const {theme} = useTheme();

    useEffect(() => {
        if (query.length > 0) {
            const fetchData = async () => {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_SC_API_BASE_URL}/api/community/search?query=${query}`
                    );
                    setResults(response.data);
                } catch (err) {
                    console.error("Error fetching data:", err);
                }
            };
            fetchData();
        } else {
            setResults([]);
        }
    }, [query]);

    const handleSelect = (event, value) => {
        if (value && !tags.includes(value.name) && tags.length < 3) {
            setTags([...tags, value.name]);
            setQuery(""); // Clear the text input
        }
    };

    const handleCreateTag = (event) => {
        if (
            event.key === "Enter" &&
            query &&
            !tags.includes(query) &&
            tags.length < 3
        ) {
            setTags([...tags, query]);
            setQuery(""); // Clear the text input
        }
    };

    return (
        <div>
            <Box sx={{mb: 2}}>
                {tags.map((tag, index) => (
                    <StyledChip
                        key={index}
                        label={tag}
                        onDelete={() => setTags(tags.filter((t) => t !== tag))}
                        sx={{
                            mr: "1rem",
                            mt: "1rem",
                            color: theme.palette.text.dark,
                            backgroundColor: theme.palette.primary.main,
                        }}
                    />
                ))}
            </Box>
            <Autocomplete
                options={results}
                getOptionLabel={(option) => option.name}
                onInputChange={(event, newInputValue, reason) => { if (reason === "input") setQuery(newInputValue); }}
                onChange={handleSelect}
                inputValue={query}
                renderInput={(params) => (
                    <StyledTextField
                        {...params}
                        label="Search or create tags..."
                        variant="outlined"
                        fullWidth
                        onKeyDown={handleCreateTag}
                        InputLabelProps={{
                            style: {color: theme.palette.secondary.main},
                        }}
                        sx={{
                            marginTop: "1rem",
                            color: theme.palette.secondary.main,
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    borderColor: theme.palette.primary.main,
                                },
                                "&:hover fieldset": {
                                    borderColor: theme.palette.primary.main,
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: theme.palette.primary.main,
                                },
                                "&.MuiAutocomplete-root": {
                                    backgroundColor: `${theme.palette.background.default} !important`,
                                },
                            },
                            "& .MuiInputBase-input": {
                                color: theme.palette.secondary.main,
                                backgroundColor: `${theme.palette.background.default} !important`,
                            },
                            "& input:-webkit-autofill": {
                                WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.default} inset !important`,
                                WebkitTextFillColor: `${theme.palette.secondary.main} !important`,
                            },
                        }}
                    />
                )}
            />
        </div>
    );
};